import { render, staticRenderFns } from "./AboutCommitteesIntro.vue?vue&type=template&id=5ed25e23&"
import script from "./AboutCommitteesIntro.vue?vue&type=script&lang=js&"
export * from "./AboutCommitteesIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports